import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/dashboards';

export const getDashboard = async (pid) => {
  return axios.get(`${endPoint}/${pid}`, {});
};

export const updateProjectData = async (pid, body) => {
  return axios
    .put(`${endPoint}/${pid}`, body, {})
    .then((res) => res)
    .catch((error) => error);
};
